import { render, staticRenderFns } from "./NotificacoesData.vue?vue&type=template&id=5abb9c14"
import script from "./NotificacoesData.vue?vue&type=script&lang=js"
export * from "./NotificacoesData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports